module.exports = __webpack_public_path__ + "static/media/add_btn.3299a928.svg";